<template>
    <div class="" :class="inputType === 'password' ? 'authentication-login__show-password' : ''">
        <div :style="{ minHeight: '24px'}">{{ title }}</div>
        <div v-if="error">
            <small class="text-danger">{{ errorText }}</small>
        </div>
        <div v-if="subText" style="display: flex; justify-content: space-between;">
            <span class="input__subtext">{{ subText }}</span>
            <span v-if="optional" class="input__subtext">{{ optional }}</span>
        </div>
        <input
            v-model="computedValue"
            :class="{
              inputClass,
              'input--error': error,
              'input--succes': ! error && modelValue !== '' && checked
            }"
            :name="name"
            :id="id"
            class="input"
            :type="inputType"
            @blur="checkError"
            @keyup="checkErrorRealTime"
            :maxlength="maxlength"
            :placeholder="placeholder"
        >
        <span
            v-if="inputType === 'password'"
            class="existing_passwd_toggle authentication-login__show-password__password-button"
            id="existing_passwd_toggle"
            data-password-target="#passwd"
        ><i class="fa fa-eye" aria-hidden="true"></i></span>
    </div>
</template>

<script>
export default {
    name: "InputText",
    props: {
        title: {
            required: false,
            default: "",
        },
        inputType: {
            type: String,
            required: false,
            default: 'text'
        },
        maxlength: Number | String,
        data: Object | String,
        errorText: String,
        name: String,
        id: String,
        placeholder: String,
        replaceItem: Boolean,
        inputClass: String,
        subText: {
            type: [String, Boolean],
            default: false
        },
        optional: {
            type: [String, Boolean],
            default: false
        },
        modelValue: {
            type: [String, Number, Boolean, Array],
            default: null,
        },
    },
    emits: ["update:modelValue"],
    data() {
        return {
            error: null,
            currentValue: '',
            checked: false,
        };
    },
    methods: {
        checkErrorRealTime(event){
            if (! this.data.$error) {
                this.error = false;
                if (event.code === 'Enter'){
                    this.$emit('keyup', event);
                }
            }
        },
        checkError() {
            this.data.$touch();

            this.checked = true;

            if (this.data.$error) {
                this.error = true
                return;
            }

            this.error = false;
        },
    },
    computed: {
        computedValue: {
            get: function () {
                if (! this) {
                    return "";
                }
                return this.modelValue;
            },
            set: function (value) {
                this.$emit("update:modelValue", value);
            },
        }
    },
    watch: {
        data() {
            this.currentValue = typeof this.data !== 'object' ? this.data : "";
        },
        'data.$error': {
            deep: true,
            initial: true,
            handler(hasError) {
                this.error = hasError;
            }
        }
    }
};
</script>
